module.exports = Array.from;